// Firebase Phone Auth (web). These values are public by design — they ship to the
// browser; security comes from Authorized Domains + Firebase rules, not secrecy.
import { initializeApp } from 'firebase/app'
import { getAuth, type Auth } from 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyBedrPkoh0wxPZL6Lm3PMzLZTzxr2GNzUE',
  authDomain: 'ahirwal-matrimony.firebaseapp.com',
  projectId: 'ahirwal-matrimony',
  storageBucket: 'ahirwal-matrimony.firebasestorage.app',
  messagingSenderId: '347098527786',
  appId: '1:347098527786:web:6b3f14f7874064c559ab53',
}

export const firebaseEnabled = true
const app = initializeApp(firebaseConfig)
export const auth: Auth = getAuth(app)
